import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { ARTIFACTS_LABEL } from './accountModel'
import { AgentNameProvider } from './agentName'
import { CfoSetupDesktop } from './CfoSetupDesktop'
import { CfoSetupMobile } from './CfoSetupMobile'
import { DESKTOP_WIDTH, MOBILE_WIDTH, OptionSection } from './OptionSection'

/** Unnamed still: naming the agent is the last thing this conversation asks. */
const AGENT_NAME = 'Cai'

export function ProductOnboardingSection({ shellClass }: { shellClass: string }) {
  // Remounting is the reset: every bit of state these screens hold is their own.
  const [run, setRun] = useState(0)

  return (
    <AgentNameProvider name={AGENT_NAME} artifactsLabel={ARTIFACTS_LABEL}>
      <OptionSection
        title="Product onboarding"
        defaultOpen
        action={
          <Button size="sm" variant="outline" onClick={() => setRun((count) => count + 1)}>
            Reset
          </Button>
        }
        panes={[
          {
            label: 'Enable CFO · new tab',
            width: DESKTOP_WIDTH,
            content: <CfoSetupDesktop key={run} className={shellClass} />,
          },
          {
            label: 'Mobile web',
            width: MOBILE_WIDTH,
            content: <CfoSetupMobile key={run} className={shellClass} />,
          },
        ]}
      />
    </AgentNameProvider>
  )
}
